import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full p-3"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"flex animate-pulse flex-col items-center h-full justify-start bg-white p-8 rounded-2xl shadow\"><div class=\"w-full flex flex-row justify-end items-center mb-3\"><div class=\"w-1/3 bg-gray-300 h-6 rounded-md shadow-card\"></div></div><div class=\"w-24 h-24 bg-gray-300 rounded-lg mb-5\"></div><div class=\"flex flex-col w-full justify-center items-center\"><div class=\"w-5/6 bg-gray-300 h-6 rounded-md\"></div></div><div class=\"flex flex-col space-y-3 w-2/3 mt-6\"><div class=\"w-2/2 bg-gray-300 h-6 rounded-md\"></div><div class=\"w-2/2 bg-gray-300 h-6 rounded-md\"></div><div class=\"w-2/2 bg-gray-300 h-6 rounded-md\"></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "w-full p-3"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"flex animate-pulse flex-col items-center h-full justify-start p-12 bg-white rounded-2xl shadow\"><div class=\"w-full h-32 bg-gray-300 rounded-lg mb-5\"></div><div class=\"w-24 h-24 bg-gray-300 rounded-lg mb-5 -mt-16 border\"></div><div class=\"flex flex-col space-y-3 w-2/3 mt-6\"><div class=\"w-2/2 bg-gray-300 h-6 rounded-md\"></div></div></div>", 1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 2,
  class: "w-full p-2"
}
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"flex animate-pulse flex-row items-center h-full justify-start p-8 bg-white rounded-2xl shadow-card space-x-3\"><div class=\"w-full space-y-2\"><div class=\"w-full bg-gray-300 h-6 rounded-md\"></div></div><div class=\"w-full space-y-2\"><div class=\"w-1/2 bg-gray-300 h-3 rounded-md\"></div><div class=\"w-full bg-gray-300 h-6 rounded-md\"></div></div><div class=\"w-full space-y-2\"><div class=\"w-1/2 bg-gray-300 h-3 rounded-md\"></div><div class=\"w-full bg-gray-300 h-6 rounded-md\"></div></div><div class=\"w-full space-y-2\"><div class=\"w-1/2 bg-gray-300 h-3 rounded-md\"></div><div class=\"w-full bg-gray-300 h-6 rounded-md\"></div></div></div>", 1)
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.type === 'job')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.type === 'company')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : _createCommentVNode("", true),
    (_ctx.type === 'job-card')
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
      : _createCommentVNode("", true)
  ], 64))
}